import React from 'react';
import Banner from '../../../components/Banner';
import BannerInfo from './BannerInfo';
import Spacer from '../../../components/Spacer';
import Info from './Info';
import Collapsible from './Collapsible';
import BannerInfoGd from './BannerGd';

function Idecaba() {
  return (
    <>
    <Banner titleSection={'¿QUÉ ES IDECABA?'} linkName={'Inicio'} nameSection={'¿QUE ES IDECABA?'} />
    <Spacer/>
    <Info/>
    <Spacer/>
    <BannerInfo/>
    <Spacer/>
    <Collapsible/>
    <Spacer/>
    <BannerInfoGd/>

    </>
  )
}

export default Idecaba